export const firstName = (user) => {
  const n = user?.profile?.first_name || (user?.name || "").trim().split(/\s+/)[0] || "";
  return n ? n.charAt(0).toUpperCase() + n.slice(1) : "";
};
